import React, { memo } from 'react';
import styled from 'styled-components';

import { Pagination } from '@rover/components/src/navigation';
import { PaginationWrapper } from '@rover/components/src/navigation/Pagination/Pagination';
import MQ from '@rover/kibble/styles/MediaQuery';
import { Alignment, HorizontalLayout } from '@rover/react-lib/src/components/layouts';
import type { Pagination as PaginationType } from '@rover/types/src/Pagination';

export type Props = {
  pagination: PaginationType;
  onPageChange: (arg0: number) => void;
};
const SearchPaginationWrapper = styled(HorizontalLayout)`
  ${MQ.SM_UP.toString()} {
    background-color: ${({ theme }) => theme.background.secondary};
  }
  ${PaginationWrapper} > ul {
    margin-bottom: ${({ theme }) => theme.space['6x']};
    margin-top: ${({ theme }) => theme.space['6x']};
  }
  ${PaginationWrapper} > ul > li {
    background-color: ${({ theme }) => theme.background.primary};
  }
  ${PaginationWrapper} > ul > li.break {
    cursor: auto;
  }
`;

const SearchPagination = ({
  pagination: { page, pageCount },
  onPageChange,
}: Props): JSX.Element => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {!!(pageCount && pageCount > 1) && (
      <SearchPaginationWrapper hAlign={Alignment.CENTER}>
        {/* @ts-expect-error react-pagination "requires" the pageRangeDisplayed prop but this has been working fine without it so :shrug: */}
        <Pagination
          disableInitialCallback
          pageCount={pageCount}
          forcePage={page && page - 1}
          onPageChange={(p) => onPageChange(p.selected + 1)}
        />
      </SearchPaginationWrapper>
    )}
  </>
);

export default memo(SearchPagination);
